import { DentalSupplierAddresses } from './../../models/dental-supplier-addresses';
import { DeleteDentalSupplierAddressesByPkService } from './../../services/delete-dental-supplier-addresses-by-pk.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
@Component({
  selector: 'app-delete-address',
  templateUrl: './delete-address.component.html',
  styleUrls: ['./delete-address.component.scss']
})
export class DeleteAddressComponent implements OnInit {
  /* --------------------------------- Fields --------------------------------- */
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private dialogRef: MatDialogRef<DeleteAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DentalSupplierAddresses,
    private deleteDentalSupplierAddressesByPkService: DeleteDentalSupplierAddressesByPkService,
    private toast: ToastService
  ) { }
  /* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
  }
  /* ------------------------------ Close Dialog ------------------------------ */
  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }
  delete() {
    console.log('hello');
    this.deleteDentalSupplierAddressesByPkService.deleteDentalSupplierAddressesByPk(this.data.id).
      subscribe(success => {
        this.toast.openSnackBar("Address is deleted successfully");
        this.closeDialog('yes');
      }, failure => {
        this.toast.openSnackBar("Unable to delete address");
      })
  }
}
